/* HueBack — comportements communs des landings (hb-lp-*) */
(function () {
  var root = document.querySelector('[class^="hbl-"]');
  if (!root) return;

  /* 1. paramètres de campagne (utm, fbclid…) conservés sur les liens produit */
  var qs = window.location.search.replace(/^\?/, '');
  if (qs) {
    var keep = qs.split('&').filter(function (p) { return /^(fbclid|gclid|ttclid|wbraid|gbraid|utm_[a-z]+)=/i.test(p); });
    if (keep.length) {
      root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        a.href += (a.href.indexOf('?') > -1 ? '&' : '?') + keep.join('&');
      });
    }
  }

  /* 2. variante de contenu (?v=factory …) */
  try {
    var v = new URLSearchParams(window.location.search).get('v');
    if (v && /^[a-z0-9-]+$/i.test(v)) root.classList.add('hb-v-' + v);
  } catch (e) {}

  /* 3. date éditoriale du jour */
  var d = document.getElementById('hb-upd-date');
  if (d) {
    var now = new Date();
    d.textContent = now.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  }

  /* 4. barre CTA collante : visible après le haut de page, masquée en fin de page et quand le panier est ouvert */
  var bar = root.querySelector('.hb-sticky-cta, .hb-stickybar, #hb-stickyCta, #hb-sticky-cta');
  if (bar) {
    var cd = document.getElementById('fp-cd');
    var pw = document.querySelector('.page-wrapper');
    var sc = function () { return (window.innerWidth >= 990 && pw) ? pw : (document.scrollingElement || document.documentElement); };
    var links = [].slice.call(root.querySelectorAll('a[href*="/products/"]')).filter(function (a) { return !bar.contains(a); });
    var last = links[links.length - 1];
    var update = function () {
      var c = sc(), y = c.scrollTop;
      var atEnd = last ? last.getBoundingClientRect().top < window.innerHeight : false;
      var show = y > 650 && !atEnd && !(cd && cd.classList.contains('on'));
      bar.classList.toggle('hb-on', show);
      bar.classList.toggle('hb-show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', update, { passive: true });
    if (pw) pw.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if (cd && window.MutationObserver) new MutationObserver(update).observe(cd, { attributes: true, attributeFilter: ['class'] });
    update();
  }
})();
